﻿import {translation} from "@2d-front-monorepo/core";
import {JSX} from "react";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {AddUpdateCreditCard} from "../../components/AddUpdateCreditCard";
import {useCreditCardAssignment} from "../../hooks/useCreditCardAssignment";

export default function Payments(): JSX.Element {
	const creditCardAssignment = useCreditCardAssignment("creditcard");

	return (
		<>
			<h1>{translation(PermitTranslations.payments_page__title)}</h1>
			<hr/>
			<div className={"payments-page-card"}>
				<AddUpdateCreditCard allowUpdate={true} allowRemove={true} creditCardAssignment={creditCardAssignment}/>
			</div>

		</>
	);
}
